import { render, staticRenderFns } from "./LogoControlSoft.vue?vue&type=template&id=83b33db2&lang=pug"
import script from "./LogoControlSoft.vue?vue&type=script&lang=js"
export * from "./LogoControlSoft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
